

















































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import { DxButton, DxTooltip, DxCheckBox, DxRadioGroup, DxLoadPanel, DxLookup, DxSelectBox, DxScrollView, DxLoadIndicator  } from 'devextreme-vue';
import { DxHtmlEditor, DxItem, DxToolbar } from 'devextreme-vue/html-editor';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxResponsiveBox, DxLocation, DxCol, DxRow } from 'devextreme-vue/responsive-box';
import _ from 'lodash';
import { Popup } from '@questelservices/common-vue';
import dialog from 'devextreme/ui/dialog';
import MatterDetails from '@/components/matter/matter-details.vue';
import { PhaseTypeDto } from '@/models/PhaseTypeDto';
import { BatchDto } from '@/models/batch/BatchDto';
import { AnalysisTextReviewDto } from '@/models/AnalysisTextReviewDto';
import { ClientService } from '../../service/ClientService';
import { SelectOption } from '../../models/SelectOption';
import { ActivityPlannerService } from '@/service/ActivityPlannerService';
import { BatchService } from '../../service/BatchService';
import { BatchTypeEnum } from '@/models/batch/BatchTypeEnum';
import { TextTemplateService } from '@/service/TextTemplateService';
import { TextTemplateTypeEnum } from '@/models/TextTemplateTypeEnum';
import CustomStore from 'devextreme/data/custom_store';
import { AnalysisReportPrintDataOptionsType } from '@/models/AnalysisReportPrintDataOptionsType';
import * as overlay from 'devextreme/ui/overlay';
import { ManualCodeInvoiceLineItemNotesDto } from '@/models/ManualCodeInvoiceLineItemNotesDto';

@Component({
  components: {
    DxSelectBox,
    DxLookup,
    DxButton,
    DxRadioGroup,
    DxCheckBox,
    DxToolbarItem,
    DxItem,
    DxHtmlEditor,
    DxToolbar,
    DxResponsiveBox,
    DxLocation,
    DxCol,
    DxRow,
    DxScrollView,
    DxLoadIndicator,
    Popup,
    MatterDetails
  }
})
export default class AnalysisTextReview extends Vue {
    private readonly matterDetailsRef: string = 'matterDetails';

    private client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');
    private activityPlannerService: ActivityPlannerService = new ActivityPlannerService('api');
    private batchService: BatchService = new BatchService();
    private phaseTypes: PhaseTypeDto[] = [];
    clients: Array<SelectOption> = [];
    selectedClient: Guid = '';
    batches: Array<SelectOption> = [];
    selectedBatch: Guid = '';
    showDialog: boolean = false;
    loadingAnalysisTexts: boolean = false;
    
    analysisTexts: Array<AnalysisTextReviewDto> = [];   
    analysisTextsOrig: Array<AnalysisTextReviewDto> = []; 

    private printOptionsStrings: SelectOption[] = [
      { text: 'Do Not Print', value: AnalysisReportPrintDataOptionsType.DoNotPrint },
      { text: 'Single Line Item Only', value: AnalysisReportPrintDataOptionsType.SingleLineItem },
      { text: 'Entire Phase Data', value: AnalysisReportPrintDataOptionsType.EntirePhase },
      { text: 'Entire Case Data', value: AnalysisReportPrintDataOptionsType.EntireCase }          
    ];

    constructor() {      
      super();
    }

    mounted() {
      this.loadData();
    }
    async loadData() {
      this.phaseTypes = await this.client.get<PhaseTypeDto[]>('/api/phasetype/all');

      let clientService = new ClientService();
      let clients = await clientService.getAll();
      this.clients = clients.map(c => { return { text: c.ClientName, value: c.ClientId } });
    }

    show() {
      this.showDialog = true;
    }

    close() {
      this.showDialog = false;
    }    

    onPopUpHidden(e: any) {
        this.$emit('analysis-text-review-hidden');
    }

    onPopupShowing(e: any) {
        this.selectedClient = '';
        this.selectedBatch = '';
    }

    @Watch('selectedClient')
    private async clientChanged() {
      this.batches = [];
      this.selectedBatch = '';
      if(this.selectedClient) {        
        let batches = await this.batchService.getClientBatches(this.selectedClient, true);        
        this.batches = batches.map(b => { return { text: b.BatchName, value: b.BatchId } });      
        
        if(batches.length > 0) {
          this.selectedBatch = batches[0].BatchId;
        }        
      }
    }

    @Watch('selectedBatch')
    private async batchChanged() {
      this.analysisTexts = [];
      if(this.selectedClient && this.selectedBatch) {
        this.loadingAnalysisTexts = true;
        this.analysisTextsOrig = await this.activityPlannerService.getAnalysisTexts(this.selectedClient, this.selectedBatch);
        this.analysisTexts = _.cloneDeep(this.analysisTextsOrig);
        this.loadingAnalysisTexts = false;      
      }
    }

    private get matterDetails() {
      return this.$refs[this.matterDetailsRef] as MatterDetails;
    }

    private showMatterDetails(item: AnalysisTextReviewDto) {
      this.matterDetails.matter = {
        MatterId: item.MatterId,
        MatterName: item.MatterName,
        ClientName: item.ClientName,
        CountryCode: item.Country
      };
      this.matterDetails.show();
    }

    private getNotesLabelColor(phaseTypeId: number) {
      let color = 'FFFFFF';
      let phaseType = this.phaseTypes.filter(p => p.PhaseTypeId == phaseTypeId)[0];
      
      if(phaseType != null) {
        color = this.phaseTypes.filter(p => p.PhaseTypeId == phaseTypeId)[0].RgbHex;
      }

      return color;
    }

    private getNotesLabel(item: AnalysisTextReviewDto)
    {
      let label = `${item.MatterName}, ${item.Country}, ${item.AgentName}, ${item.AssignedPhaseName}`;
      return label;
    }

    private saveChanges() {      
      let updatedNotes: ManualCodeInvoiceLineItemNotesDto[] = this.analysisTexts.filter(a => this.isModified(a))
        .map(a => {
          return {
            InvoiceLineItemId: '00000000-0000-0000-0000-000000000000',
            InvoiceLineItemNotesId: a.LineItemNotesId,            
            PrivateAuditorNotes: '',
            AuditorNotesReportLanguage: a.AnalysisText,
            AnalysisReportPrintDataOptionsType: a.AnalysisReportPrintDataOptionsType,
            MarkImportant: false,
            PrintCommentsAuditorReport: a.PrintCommentsAuditorReport,
            IncludeAllAgentsCharges: a.IncludeAllAgentsCharges,
            PhaseHistory: ''
          }
      });

      this.client.postJson('/api/manualcoding/bulk-modify-notes', updatedNotes);
      this.close();
    }

    private isModified(analysisText: AnalysisTextReviewDto) : boolean {
      let originalAnalysisText = this.analysisTextsOrig.filter(a => a.LineItemNotesId == analysisText.LineItemNotesId)[0];

      if (originalAnalysisText.AnalysisText != analysisText.AnalysisText) {
        return true;
      }

      if (originalAnalysisText.AnalysisReportPrintDataOptionsType != analysisText.AnalysisReportPrintDataOptionsType) {
        return true;
      }

      if (originalAnalysisText.PrintCommentsAuditorReport != analysisText.PrintCommentsAuditorReport) {
        return true;
      }

      if (originalAnalysisText.IncludeAllAgentsCharges != analysisText.IncludeAllAgentsCharges) {
        return true;
      }

      return false;
    }

    // add CSS class to color the text boxes yellow if the text has been modified by the user
    private onTextChanged(item: any, lineItemNotesId: Guid) {
      let analysisTextItem = this.analysisTexts.filter(a => a.LineItemNotesId == lineItemNotesId)[0];
      analysisTextItem.AnalysisText = item.value;
      let originalAnalysisText = this.analysisTextsOrig.filter(a => a.LineItemNotesId == lineItemNotesId)[0].AnalysisText;

      if (originalAnalysisText != item.value) {
        item.element.classList.add('analysis-text-modified')
      }     
      else {
        item.element.classList.remove('analysis-text-modified')
      }
    }
}
